import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { useNavigate } from 'react-router-dom';

const steps = [
  {
    step: '01',
    title: '揀返一棵有連結感嘅樹',
    desc: '唔一定要係最大最靚嘅果棵。行入公園、慢慢感受，邊棵樹會令你停低多兩秒？就係佢。信直覺，佢會揀你，多過你揀佢。',
    icon: 'ri-search-eye-line',
    tip: '揀樹身直徑至少過大脾嘅樹，能量會更加穩定。',
  },
  {
    step: '02',
    title: '接觸．手心貼上樹幹',
    desc: '深呼吸三次，然後將雙手手心貼落樹皮。可以額頭都貼埋上去。合埋眼，感受樹皮嘅溫度、紋理，同微微嘅震動。',
    icon: 'ri-hand-heart-line',
    tip: '手心（勞宮穴）係接收能量最敏感嘅位置，唔好用力，只需要「放」上去。',
  },
  {
    step: '03',
    title: '感受．留 3–20 分鐘',
    desc: '喺呢段時間，唔需要諗嘢，只係呼吸。如果有情緒浮上嚟，讓佢流。完成前，可以喺心入面同棵樹講一句多謝，然後慢慢離開。',
    icon: 'ri-time-line',
    tip: '第一次嘗試，建議 3 分鐘就夠。感受清楚咗，下次先延長。',
  },
];

const precautions = [
  {
    icon: 'ri-error-warning-line',
    title: '避開有蟲蟻嘅樹',
    desc: '接觸前先觀察樹皮有冇螞蟻、蛞蝓或蜘蛛網，尤其係春夏濕熱季節。',
  },
  {
    icon: 'ri-shirt-line',
    title: '著長袖薄外套',
    desc: '接觸樹皮嘅時候，避免皮膚直接磨損。花粉敏感人士建議戴口罩。',
  },
  {
    icon: 'ri-map-pin-line',
    title: '揀相對僻靜嘅位置',
    desc: '減低尷尬感、增加放鬆效果。郊野公園或私人花園比人多嘅市區公園更適合。',
  },
  {
    icon: 'ri-leaf-line',
    title: '尊重樹，唔好折枝',
    desc: '抱樹係「連結」，唔係「佔有」。唔好刻名、唔好折葉。',
  },
  {
    icon: 'ri-mental-health-line',
    title: '嚴重情緒困擾請專業求助',
    desc: '抱樹係補充性嘅療癒方式，唔可以取代心理治療或精神科治療。如有需要，請聯絡專業人士。',
  },
];

export default function Steps() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            <div className="max-w-3xl mb-16">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#3A4D39]/15 text-[#2C3E2B] text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-footprint-line"></i>
                實用指南 · How To
              </div>
              <h2 className="font-heading text-4xl md:text-6xl font-medium text-foreground-950 leading-tight">
                三個步驟， <br />
                <span className="italic text-[#3A4D39]">開始你第一次擁抱</span>
              </h2>
              <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
                抱樹唔難，難嘅係俾自己「慢落嚟」呢個許可。跟住呢三步做，溫柔咁開始。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
              {steps.map((s, idx) => (
                <div
                  key={s.step}
                  className={`relative rounded-3xl p-8 md:p-9 flex flex-col ${
                    idx === 1
                      ? 'bg-[#3A4D39] text-background-50 border border-[#3A4D39]'
                      : 'bg-background-100 border border-background-200/70 text-foreground-900'
                  }`}
                >
                  <div className="flex items-center justify-between mb-6">
                    <div
                      className={`w-14 h-14 flex items-center justify-center rounded-2xl ${
                        idx === 1
                          ? 'bg-background-50/20 text-background-50'
                          : 'bg-[#3A4D39] text-background-50'
                      }`}
                    >
                      <i className={`${s.icon} text-2xl`}></i>
                    </div>
                    <span
                      className={`font-heading text-5xl font-medium ${
                        idx === 1 ? 'text-background-50/40' : 'text-foreground-950/10'
                      }`}
                    >
                      {s.step}
                    </span>
                  </div>

                  <h3 className="font-heading text-2xl font-medium leading-snug">{s.title}</h3>
                  <p
                    className={`mt-4 text-sm leading-relaxed flex-1 ${
                      idx === 1 ? 'text-background-50/90' : 'text-foreground-700'
                    }`}
                  >
                    {s.desc}
                  </p>

                  <div
                    className={`mt-6 rounded-2xl p-4 flex gap-3 items-start ${
                      idx === 1 ? 'bg-background-50/15' : 'bg-[#3A4D39]/8 border border-[#3A4D39]/15'
                    }`}
                  >
                    <i className={`ri-lightbulb-flash-line text-lg mt-0.5 ${idx === 1 ? 'text-[#7BA878]' : 'text-[#3A4D39]'}`}></i>
                    <p className={`text-xs leading-relaxed ${idx === 1 ? 'text-background-50/90' : 'text-foreground-700'}`}>
                      {s.tip}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="rounded-3xl bg-[#3A4D39]/8 border border-[#3A4D39]/20 p-8 md:p-12">
              <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
                <div>
                  <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#3A4D39]/25 text-[#2C3E2B] text-xs font-semibold tracking-widest uppercase mb-4 whitespace-nowrap">
                    <i className="ri-shield-check-line"></i>
                    注意事項 · Cautions
                  </div>
                  <h3 className="font-heading text-3xl md:text-4xl font-medium text-foreground-950 leading-tight">
                    開始前，請留意呢 5 件事
                  </h3>
                </div>
                <p className="max-w-md text-sm text-foreground-700 leading-relaxed">
                  溫柔對待自己，同樣重要嘅係，溫柔對待棵樹同附近嘅生態。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {precautions.map((p) => (
                  <div key={p.title} className="rounded-2xl bg-background-50 p-5 border border-[#3A4D39]/15 flex gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#3A4D39]/15 text-[#2C3E2B] shrink-0">
                      <i className={`${p.icon} text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-base font-semibold text-foreground-900">{p.title}</h4>
                      <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{p.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}